const ERROR_PREFIX = 'ERROR_';

export const ERROR_TYPE = {
  API: ERROR_PREFIX + 'API',
  INPUT: ERROR_PREFIX + 'INPUT',
  HOOK: ERROR_PREFIX + 'HOOK',
  MESSAGE: ERROR_PREFIX + 'MESSAGE',
  STATIC: ERROR_PREFIX + 'STATIC',
  UNCATEGORIZED: ERROR_PREFIX + 'UNCATEGORIZED',
};
